.wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: calc(var(--spacing) * 2) calc(var(--spacing) * 3) var(--spacing);
  gap: calc(var(--spacing) * 2);
}

.title {
  font-size: 16px;
  font-weight: 500;
}

.message {
  font-size: 13px;
  color: #da0a2b;
}
